module.exports = __webpack_public_path__ + "img/263028688.358349d9.jpg";